import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 2h8l4 10H4L8 2Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 12v6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Lamp";
const Lamp = memo(themed(Icon));
export {
  Lamp
};
//# sourceMappingURL=lamp.js.map
